import React from "react";
import css from './HeaderLoader.module.scss';

export default function HeaderLoader() {
    return (
        <div className={css.header}>
            <div className={css.left}>
                <div className={css.row} />
                <div className={css.row} />
            </div>
            <div className={css.right}>
                <div className={css.row} />
                <div className={css.row} />
            </div>
        </div>
    );
}
